// libs
import get from "lodash/get";

// constants
import { WIDGET_TYPES, PLACE_HOLDER_COLORS } from "./constants";

// def
import { ILandingPageWidget, IWidgetItems } from "./types";

export const sortByKey = (parent: IWidgetItems[], key: string): IWidgetItems[] => {
    let sortedArray: IWidgetItems[];
    sortedArray = parent.slice().sort(function(a, b) {
        return (get(a, key) as number) - (get(b, key) as number);
    });
    return sortedArray;
};

export const generateTrackingParams = (
    inventoryName: string,
    position: number,
    trackingParams: string
) => {
    const inventory_name = inventoryName.replace(new RegExp(/([.])+/g), ",").trim();
    return `intcmp=${inventory_name},${position},${trackingParams}`;
};

export const generateTrackingUrl = (
    url: string,
    inventoryName: string,
    position: number,
    trackingParams: string
) => {
    if (!url) return "";

    const paramsExp = new RegExp(/([?])+/g);
    const trackingUrl = paramsExp.test(url)
        ? `${url}&${generateTrackingParams(inventoryName, position, trackingParams)}`
        : `${url}?${generateTrackingParams(inventoryName, position, trackingParams)}`;

    return trackingUrl;
};

export const getMetaData = (landingPageData: ILandingPageWidget[]) => {
    const landingPageWidget = landingPageData.find(
        widgetData => widgetData.widget_data.wtype === WIDGET_TYPES.SEO_DATA
    );
    return get(landingPageWidget, "widget_data.parameters");
};

const sortedWidgetChildren = (widget: ILandingPageWidget): IWidgetItems[] => {
    return sortByKey(get(widget, "widget_data.children", []), "positionInParent");
};

interface IGetCarouselImagesProps {
    widget: ILandingPageWidget;
    options: {
        urlSource: string;
        aspectRatioSrc: string;
        defaultAspectRatio: number;
        fallBackUrlSource?: string;
        fallBackAspectRatioSrc?: string;
        fallBackDefaultAspectRatio?: number;
    };

    inventoryName: string;
}

export const getCarouselImages = ({ widget, options, inventoryName }: IGetCarouselImagesProps) =>
    sortedWidgetChildren(widget).map((child: IWidgetItems) => {
        const data = get(child, "children[0].source", {});
        const defaultURLSource = get(data, options.urlSource, "");

        const action_url = generateTrackingUrl(
            child.parameters.web_action_url,
            inventoryName,
            child.positionInParent,
            child.parameters.tracking_parameters
        );

        if (defaultURLSource) {
            return {
                url: defaultURLSource,
                aspect_ratio: get(data, options.aspectRatioSrc, options.defaultAspectRatio),
                action_url,
            };
        } else if (
            options.fallBackUrlSource &&
            options.fallBackAspectRatioSrc &&
            options.fallBackDefaultAspectRatio
        ) {
            return {
                url: get(data, options.fallBackUrlSource, ""),
                aspect_ratio: get(
                    data,
                    options.fallBackAspectRatioSrc,
                    options.fallBackDefaultAspectRatio
                ),
                action_url,
            };
        }
        return {};
    });

export const getPlaceHolderColor = (id?: number) => {
    const placeholderKeys = Object.keys(PLACE_HOLDER_COLORS);
    const indx = id
        ? id % placeholderKeys.length
        : Math.floor(Math.random() * placeholderKeys.length);

    return get(PLACE_HOLDER_COLORS, placeholderKeys[indx]);
};
